import { Deserializable } from '../deserializable';
import { ArbFacilitator } from '../general/arb-facilitator';
import { Broker } from '../general/broker';
import { formatDate } from '@angular/common';
export class Transaction implements Deserializable {
  /* 
    PreliminaryProfit = Total profit/loss from Dooya email eg "TOTAL PROFIT/LOSS: 2,342.48 (1.44 %)"
    TradeProfit = ClearedTradeAmount - TradeAmount eg. Total Amount Owed from DOOYA: 165,241.70 - Total ZAR Sent: 163,500.00 (minus R500) = R2241.70
    TotalProfit = TradeProfit - BrokerBillingPercentage eg. R2241.70-10% = R2017.53
    */

  id: number;
  arbFacilitatorId: number;
  arbFacilitator: ArbFacilitator;
  brokerId: number;
  broker: Broker;
  userId: number;
  amountSent: number;
  amountSentCurrencyId: number;
  amountReceived: number;
  amountReceivedCurrencyId: number;
  forexRate: number;
  forexRateCurrencyId: number;
  preliminaryProfit: number;
  preliminaryProfitCurrencyId: number;
  preliminaryProfitPercentage: number;
  arbFacilitatorFeePercentage: number;
  arbFacilitatorFee: number;
  arbFacilitatorFeeCurrencyId: number;
  unspentTradeFunds: number;
  unspentTradeFundsCurrencyId: number;
  withdrawlFee: number;
  withdrawlFeeCurrencyId: number;
  totalProfit: number;
  totalProfitPercentage: number;
  transactionStartDate: string;
  transactionEndDate: string;
  totalProfitCurrencyId: number;
  clearedTradeAmount: number;
  clearedTradeAmountCurrencyId: number;
  bankFees: number;
  bankFeesCurrencyId: number;
  tradeAmount: number;
  tradeAmountCurrencyId: number;
  tradeProfit: number;
  tradeProfitCurrencyId: number;
  transactionStatusId: number;

  fiaAmount: number;
  sdaAmount: number;

  selected: boolean = false;

  deserialize(input: any): this {
    Object.assign(this, input);
    return this;
  }

  GetTradeStatusOrCompletionDate() {
    if (this.transactionEndDate != null) {
      return formatDate(this.transactionEndDate, 'MMM d, yyyy', 'en', 'UTC+2');
    }

    if (this.transactionStatusId < 200) {
      return 'Scheduled';
    }

    if (this.transactionStatusId < 300) {
      return 'In Progress';
    }

    if (this.transactionStatusId < 999) {
      return 'Completed';
    }

    if (this.transactionStatusId >= 999) {
      return 'Deleted';
    }
  }

  GetStatusName() {
    if (this.transactionStatusId < 200) {
      return 'Scheduled';
    }
    if (this.transactionStatusId < 300) {
      return 'In Progress';
    }
    if (this.transactionStatusId < 999) {
      return 'Completed';
    }
    if (this.transactionStatusId >= 999) {
      return 'Deleted';
    }  
  }
}